import { render, staticRenderFns } from "./materialize_file.vue?vue&type=template&id=0644f2aa&"
import script from "./materialize_file.vue?vue&type=script&lang=js&"
export * from "./materialize_file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports